export class ProductVariantDetailsDto {
  creationReason: string;
  isRestricted: boolean;
  id?: string;

  constructor(d?: ProductVariantDetailsDto) {
    if (d) {
      Object.assign(this, d);
    }
  }
}
